import { createNewContact, createNewSymptom } from "../../data/omniDataModel";

import constants from "../../assets/constants";
import { deepCopyObject } from "../../utils/helpers";

const generateSymptoms = (question, subjects, newSubjectArray) => {
  try {
    let newSymptomODMs = deepCopyObject(subjects);
    for (let index = 0; index < newSubjectArray.length; ++index) {
      if (!subjects.some(e => e.name === newSubjectArray[index])) {
        let newSymptom = createNewSymptom();

        let questionText = question.answerOptions.find(
          ({ value }) => value === newSubjectArray[index]
        ).text;

        newSymptom.name = questionText != null ? questionText : newSubjectArray[index];
        newSymptomODMs.push(newSymptom);
      }
    }

    return newSymptomODMs;
  } catch (error) {
    console.log(error);

    return subjects;
  }
};

export const scrapeSubjectData = (question, subjectODM) => {
  try {
    if (
      question.answerDate != null &&
      question.answerValue &&
      question.answerValue[0] !== "unsure"
    ) {
      switch (question.shortTitle) {
        case "subjectDateOfBirth":
          subjectODM.omniData.birthdate = question.answerValue[0];
          break;
        case "subjectZipCode":
          subjectODM.omniData.address.postalCode = question.answerValue[0];
          break;
        case "subjectEthnicity":
          subjectODM.omniData.ethnicity = question.answerValue[0];
          break;
        case "subjectRace":
          subjectODM.omniData.race = question.answerValue[0];
          break;
        case "subjectHeight":
          subjectODM.omniData.patientData.height = question.answerValue[0];
          break;
        case "subjectWeight":
          subjectODM.omniData.patientData.weight = question.answerValue[0];
          break;
        case "subjectCareGiver":
          try {
            let contactList = subjectODM.omniData.contacts.filter(
              obj => obj.contactType !== constants.contactTypes.primaryCaregiver
            );

            let newContact = createNewContact();

            let fieldsArray = question.answerValue[0].split(", ");
            newContact.contactName = fieldsArray[0];
            newContact.contactType = constants.contactTypes.primaryCaregiver;
            newContact.mobilePhone = fieldsArray[1];
            newContact.email = fieldsArray[2];
            contactList.push(newContact);

            subjectODM.omniData.contacts = contactList;
          } catch (error) {
            console.log(error);
          }

          subjectODM.omniData.patientData.caregiver = question.answerValue[0];

          break;
        case "subjectHypertension":
          subjectODM.omniData.patientData.hypertension = question.answerValue[0];
          break;
        case "subjectBloodPressure":
          subjectODM.omniData.patientData.bloodPressure = question.answerValue[0];
          break;
        case "subjectStroke":
          subjectODM.omniData.patientData.stroke = question.answerValue[0];
          break;
        case "subjectStrokeYear":
          subjectODM.omniData.patientData.strokeYear = question.answerValue[0];
          break;
        case "subjectStrokeSymptoms":
          subjectODM.omniData.patientData.hadStrokeSymptoms = question.answerValue[0];
          break;
        case "subjectHeartAttack":
          subjectODM.omniData.patientData.heartAttack = question.answerValue[0];
          break;
        case "subjectHeartAttackYear":
          subjectODM.omniData.patientData.heartAttackYear = question.answerValue[0];
          break;
        case "subjectHeartProblems":
          subjectODM.omniData.patientData.heartProblems = question.answerValue[0];
          break;
        case "subjectHeadTrauma":
          subjectODM.omniData.patientData.headTrauma = question.answerValue[0];
          break;
        case "subjectHeadTraumaYear":
          subjectODM.omniData.patientData.headTraumaYear = question.answerValue[0];
          break;
        case "subjectSeizures":
          subjectODM.omniData.patientData.seizures = question.answerValue[0];
          break;
        case "subjectPsychiatricConcerns":
          subjectODM.omniData.patientData.psychiatricConcerns = question.answerValue[0];
          break;
        case "subjectCancerHistory":
          subjectODM.omniData.patientData.cancerLastFiveYears = question.answerValue[0];
          break;
        case "subjectCancerType":
          subjectODM.omniData.patientData.cancerLastTypes = question.answerValue; //Array Type
          break;
        case "subjectAlcoholAbuse":
          subjectODM.omniData.patientData.alchoholAbuse = question.answerValue[0];
          break;
        case "subjectUncontrolledCondition":
          subjectODM.omniData.patientData.hasUncontrolledCondition = question.answerValue[0];
          break;
        case "subjectUncontrolledConditionDescription":
          subjectODM.omniData.patientData.uncontrolledConditionDescription =
            question.answerValue[0];
          break;
        case "subjectMRI":
          subjectODM.omniData.patientData.recentMRI = question.answerValue[0];
          break;
        case "subjectMRIYear":
          subjectODM.omniData.patientData.recentMRIYear = question.answerValue[0];
          break;
        case "subjectMedications":
          subjectODM.omniData.patientData.medicationList = question.answerValue; //Array Type
          break;
        case "subjectWorseningCognition":
          subjectODM.omniData.patientData.worseningCognition = question.answerValue[0];
          break;
        case "subjectChangeInCognition":
          subjectODM.omniData.patientData.changeInCognition = question.answerValue[0];
          break;
        case "subjectAbruptCognitiveDecline":
          subjectODM.omniData.patientData.abruptCognitiveDecline = question.answerValue[0];
          break;
        case "subjectAssistanceNeed":
          subjectODM.omniData.patientData.assistanceNeed = question.answerValue[0];
          break;
        case "subjectCognitiveDeclineOnset":
          subjectODM.omniData.patientData.cognitiveDeclineDuration = question.answerValue[0];
          break;
        case "subjectNeurologist":
          subjectODM.omniData.patientData.hasNeurologist = question.answerValue[0];
          break;
        case "subjectNeurologistReason":
          subjectODM.omniData.patientData.neurologistReasons = question.answerValue[0];
          break;
        case "subjectKnownConditions":
          subjectODM.omniData.patientData.knownConditions = question.answerValue[0];
          break;
        case "subjectCognitiveDeclineTesting":
          subjectODM.omniData.patientData.cognitiveDeclineTesting = question.answerValue[0];
          break;
        case "subjectDelirium":
          subjectODM.omniData.patientData.delirium = question.answerValue[0];
          break;
        case "subjectPreviousTrialParticipation":
          subjectODM.omniData.patientData.previousTrialParticipation = question.answerValue[0];
          break;
        case "subjectPreviousTrialDate":
          subjectODM.omniData.patientData.previousTrialTimeSeparation = question.answerValue[0];
          break;
        case "subjectMemoryTrialInterest":
          subjectODM.omniData.patientData.hasMemoryTrialInterest = question.answerValue[0];
          break;
        case "subjectNoTrialInterestReason":
          subjectODM.omniData.patientData.trialAversionReasoning = question.answerValue[0];
          break;
        case "subjectThyroidCancer":
          subjectODM.omniData.patientData.thyroidCancer = question.answerValue[0];
          break;
        case "subjectTakesSemaglutide":
          subjectODM.omniData.patientData.takesSemaglutide = question.answerValue[0];
          break;
        case "subjectHasHighBloodpressue":
          subjectODM.omniData.patientData.hasHighBloodpressue = question.answerValue[0];
          break;
        case "subjectHasTypeTwoDiabetes":
          subjectODM.omniData.patientData.hasTypeTwoDiabetes = question.answerValue[0];
          break;
        case "subjectHasHighCholesterol":
          subjectODM.omniData.patientData.hasHighCholesterol = question.answerValue[0];
          break;
        case "acceptTerms":
        case "subjectGiveEmergencyContact":
          //nothing to do, just not an error
          break;
        case "subjectApathyRank":
          subjectODM.omniData.patientData.apathyRank = question.answerValue[0];
          break;
        case "subjectDepressionRank":
          subjectODM.omniData.patientData.depressionRank = question.answerValue[0];
          break;
        case "subjectInsomniaRank":
          subjectODM.omniData.patientData.insomniaRank = question.answerValue[0];
          break;
        case "subjectLethargyRank":
          subjectODM.omniData.patientData.lethargyRank = question.answerValue[0];
          break;
        case "subjectAppetiteRank":
          subjectODM.omniData.patientData.appetiteRank = question.answerValue[0];
          break;
        case "subjectSelfWorthRank":
          subjectODM.omniData.patientData.selfWorthRank = question.answerValue[0];
          break;
        case "subjectDistractionRank":
          subjectODM.omniData.patientData.distractionRank = question.answerValue[0];
          break;
        case "subjectEnergyRank":
          subjectODM.omniData.patientData.energyRank = question.answerValue[0];
          break;
        case "subjectSuicidalIdeationRank":
          subjectODM.omniData.patientData.suicidalIdeationRank = question.answerValue[0];
          break;
        case "subjectEffectRank":
          subjectODM.omniData.patientData.effectRank = question.answerValue[0];
          break;

        case "subjectOutsideIndependence":
          subjectODM.omniData.patientData.outsideIndependence = question.answerValue[0];
          break;
        case "subjectGroomingIndependence":
          subjectODM.omniData.patientData.groomingIndependence = question.answerValue[0];
          break;
        case "subjectHomeIndependence":
          subjectODM.omniData.patientData.homeIndependence = question.answerValue[0];
          break;
        case "subjectTechnologyIndependence":
          subjectODM.omniData.patientData.technologyIndependence = question.answerValue[0];
          break;
        case "subjectMemoryIndependence":
          subjectODM.omniData.patientData.memoryIndependence = question.answerValue[0];
          break;

        case "subjectTransportIndependence":
          subjectODM.omniData.patientData.transportIndependence = question.answerValue[0];
          break;
        case "subjectOrientationIndependence":
          subjectODM.omniData.patientData.orientationIndependence = question.answerValue[0];
          break;
        case "subjectMedicationIndependence":
          subjectODM.omniData.patientData.medicationIndependence = question.answerValue[0];
          break;
        case "subjectDecisionIndependence":
          subjectODM.omniData.patientData.decisionIndependence = question.answerValue[0];
          break;
        case "subjectFinancialIndependence":
          subjectODM.omniData.patientData.financialIndependence = question.answerValue[0];
          break;

        //hair loss

        case "subjectOver18":
          subjectODM.omniData.patientData.subjectOver18 = question.answerValue[0];
          break;
        case "subjectHairLossClassification":
          subjectODM.omniData.patientData.subjectHairLossClassification = question.answerValue[0];
          break;
        case "subjectMedicalProcedures":
          subjectODM.omniData.patientData.subjectMedicalProcedures = question.answerValue[0];
          break;
        case "subjectMedications4Month":
          subjectODM.omniData.patientData.subjectMedications4Month = question.answerValue[0];
          break;
        case "subjectMedications3Months":
          subjectODM.omniData.patientData.subjectMedications3Months = question.answerValue[0];
          break;
        case "subjectMedications6MonthsA":
          subjectODM.omniData.patientData.subjectMedications6MonthsA = question.answerValue[0];
          break;
        case "subjectMedications6MonthsB":
          subjectODM.omniData.patientData.subjectMedications6MonthsB = question.answerValue[0];
          break;
        case "subjectExperimentalTreatments":
          subjectODM.omniData.patientData.subjectExperimentalTreatments = question.answerValue[0];
          break;
        case "subjectOtherSymptomsAnswer":
          subjectODM.omniData.patientData.subjectOtherSymptomsAnswer = question.answerValue[0];
          break;
        case "subjectBusinessPillar":
          subjectODM.omniData.businessPillar = question.answerValue[0];
          break;
        case "subjectSymptoms":
          let newSymptoms = generateSymptoms(
            question,
            subjectODM.omniData.patientData.symptomODMs,
            question.answerValue
          );
          subjectODM.omniData.patientData.symptomODMs = newSymptoms;
          //todo create symptom
          break;

        default:
          // code blockquestion.shortTitle
          console.log(`SCRAPE: unrecognized data attribute found: ${question.shortTitle}`);
      }

      return subjectODM;
    }

    return subjectODM;
  } catch (error) {
    console.log(error);
  }
  return subjectODM;
};

export const scoreCompletedAssessment = (completedAssessmentODM, subjectODM) => {
  try {
    if (completedAssessmentODM.omniData.omniType === constants.assessmentIDs.phq9) {
      let runningScore = 0;
      for (let index = 0; index < 9; ++index) {
        runningScore += parseInt(completedAssessmentODM.omniData.questions[index].answerValue[0]);
      }
      subjectODM.omniData.patientData.scorePHQ9 = runningScore.toString();
      return subjectODM;
    }

    if (
      completedAssessmentODM.omniData.omniType === constants.assessmentIDs.scoreIndependentFunction
    ) {
      let runningScore = 0;
      for (let index = 0; index < 10; ++index) {
        runningScore += parseInt(completedAssessmentODM.omniData.questions[index].answerValue[0]);
      }
      subjectODM.omniData.patientData.scoreIndependentFunction = runningScore.toString();
      return subjectODM;
    }

    if (completedAssessmentODM.omniData.omniType === constants.assessmentIDs.omniHealthHistory) {
      let height = 0;
      let weight = 0;
      for (let index = 0; index < completedAssessmentODM.omniData.questions.length; ++index) {
        if (completedAssessmentODM.omniData.questions[index].shortTitle === "subjectWeight") {
          weight = parseInt(completedAssessmentODM.omniData.questions[index].answerValue[0]) || 0;
        }
        if (completedAssessmentODM.omniData.questions[index].shortTitle === "subjectHeight") {
          height = parseInt(completedAssessmentODM.omniData.questions[index].answerValue[0]) || 0;
        }
      }
      if (height !== 0 && weight !== 0) {
        subjectODM.omniData.patientData.bmi = (703 * weight) / (height * height);
      }

      return subjectODM;
    }

    return subjectODM;
  } catch (error) {
    console.log(error);
  }
  return subjectODM;
};
